import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { NodePartner } from '@madeinlune/massaud-types';
import { RouterStaticLinkDirective } from '@nx-massaud/routing/link';

@Component({
  selector: 'msd-det-ui-partners',
  standalone: true,
  template: `
    <ng-container *ngIf="partners">
      <ul class="list-style-type-none">
        <ng-template ngFor [ngForOf]="partners" let-partner>
          <ng-container *ngIf="partner">
            <li>
              <a
                [innerHTML]="partner.title"
                [routerStaticLink]="partner.path"
              ></a>
            </li>
          </ng-container>
        </ng-template>
      </ul>
    </ng-container>
  `,
  styleUrls: ['./partners.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgForOf, NgIf, RouterStaticLinkDirective],
})
export class PartnersComponent {
  @Input()
  partners!: NodePartner[];
}
